import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, image, article, canonicalPath }) => {
    const { pathname } = useLocation();
    const siteUrl = 'https://foirola.com';

    // Construct the canonical URL: prefer the prop if provided, otherwise use current path.
    // Important: remove trailing slashes for consistency
    const cleanPath = (path) => path.replace(/\/$/, '');

    // If canonicalPath is provided (e.g. '/contacto'), use it. 
    // Otherwise fallback to current pathname.
    const effectivePath = canonicalPath || pathname;
    const canonicalUrl = `${siteUrl}${cleanPath(effectivePath)}`;

    const defaultTitle = 'FOIROLA | Fuengirola Brand';
    const defaultDescription = 'Marca de ropa inspirada en la cultura local de Fuengirola. Diseños exclusivos y ediciones limitadas. Moda urban y costa del sol.';
    const defaultImage = `${siteUrl}/logo512.png`;

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: image || defaultImage,
        url: canonicalUrl,
    };

    return (
        <Helmet title={seo.title} titleTemplate={`%s | FOIROLA`}>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />

            {/* Canonical Link - The Key Fix for "Duplicate" content */}
            <link rel="canonical" href={seo.url} />

            {/* OpenGraph / Facebook */}
            <meta property="og:url" content={seo.url} />
            <meta property="og:type" content={article ? 'article' : 'website'} />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:image" content={seo.image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />
        </Helmet>
    );
};

export default SEO;
